import axios from "axios"

export const BitkubService = function (config) {
    this.config = config
}

BitkubService.prototype.refreshToken = function (val = null) {
    if (val == null) {
        return localStorage.getItem("bk.refreshToken")
    } else {
        localStorage.setItem("bk.refreshToken", val)
    }
}

BitkubService.prototype.getAccessToken = function (code) {
    let uri = `${this.config.endpoint}/oauth2/access_token`
    let headers = {
        authorization: Buffer.from(this.config.clientId).toString('base64'),
        'content-type': "application/x-www-form-urlencoded;charset=utf-8"
    }

    let redirect_uri = this.config.redirectUri
    if (redirect_uri.indexOf("devlandingvue") == -1) {
        redirect_uri = `${window.location.origin}${redirect_uri}`
    }

    let data = {
        grant_type: "authorization_code",
        client_id: this.config.clientId,
        code: code,
        redirect_uri: redirect_uri,
    }
    const formEncodedBody = new URLSearchParams(Object.entries(data)).toString();
    // console.log(formEncodedBody)

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: uri,
            data: formEncodedBody,
            headers: headers,
        }).then((resp) => {
            this.refreshToken(resp.data.refresh_token) // set refresh token
            resolve(resp.data.access_token)
        }).catch((err) => {
            reject(err)
        })
    })
}

// use when access token is expired to get new access token
BitkubService.prototype.refreshAccessToken = function () {
    let uri = `${this.config.endpoint}/oauth2/access_token`
    // console.log(uri)
    let headers = {
        authorization: Buffer.from(this.config.clientId).toString('base64'),
        "content-type": "application/x-www-form-urlencoded;charset=utf-8"
    }

    let data = {
        grant_type: "refresh_token",
        client_id: this.config.clientId,
        refresh_token: this.refreshToken()
    }
    const formEncodedBody = new URLSearchParams(Object.entries(data)).toString();
    // console.log(formEncodedBody)

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: uri,
            data: formEncodedBody,
            headers: headers,
        }).then((resp) => {
            this.refreshToken(resp.data.refresh_token) // set refresh token
            resolve(resp.data.access_token)
        }).catch((err) => {
            // console.log("api error", err)
            reject(err)
        })
    })
}

BitkubService.prototype.getAccount = function (accessToken) {
    let uri = `${this.config.apiUrl}/accounts/auth/info`
    let headers = {
        authorization: `Bearer ${accessToken}`,
    }

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: uri,
            headers: headers,
        }).then((resp) => {
            resolve(resp.data)
        }).catch((err) => {
            reject(err)
        })
    })
}
